import { useEffect, useState } from "react";
import NewsletterMobile from "./NewsletterMobile";
import Newsletter from "./NewsLetter";

function NewsletterParent() {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  return isMobile ? <NewsletterMobile /> : <Newsletter />;
}

export default NewsletterParent;
